'use client';

import { useExperiments } from '@hc-frontend/core-ui';
import { trackExperimentView } from '@hc-frontend/third-party-snowplow';
import { useEffect } from 'react';

type PartnerCustomHeadingProps = {
  displayName: string;
};

export function PartnerCustomHeading({
  displayName,
}: PartnerCustomHeadingProps) {
  const { mp_2538_ucc_partner_heading } = useExperiments();

  useEffect(() => {
    if (mp_2538_ucc_partner_heading) {
      trackExperimentView({
        experimentName: 'mp_2538_ucc_partner_heading',
        variantName: mp_2538_ucc_partner_heading,
        splitSource: 'amplitude',
      });
    }
  }, [mp_2538_ucc_partner_heading]);

  if (mp_2538_ucc_partner_heading === 'variant') {
    return (
      <h1 className="hc-typography--heading-four mb-24-32 text-balance leading-tight">
        Next Step: Discuss plan options with a licensed insurance agent at{' '}
        <span className="text-secondary-900">{displayName}</span>
      </h1>
    );
  }

  return (
    <h1 className="hc-typography--heading-four mb-24-32 text-balance leading-tight">
      A licensed insurance agent at{' '}
      <span className="text-secondary-900">{displayName}</span> just became
      available!
    </h1>
  );
}
